<template>
  <div class="login">
    <NavTop title="登录" />
    <van-form @submit="onSubmit">
      <van-field
        v-model="form.phone"
        name="phone"
        label="账号"
        placeholder="手机号"
        :rules="[{ required: true, message: '账号不能为空' }]"
      />
      <van-field
        v-model="form.password"
        type="password"
        name="password"
        label="密码"
        placeholder="请输入密码"
        :maxlength="20"
        :rules="[{ required: true, message: '密码不能为空' }]"
      />
      <van-row class="login-auto">
        <van-checkbox
          class="fl-l"
          icon-size="16px"
          shape="square"
          v-model="form.isSevenDay"
          >七天内自动登录</van-checkbox
        >
        <router-link class="fl-r forget-pas" to="forgetPas">
          忘记密码？
        </router-link>
      </van-row>
      <div style="padding: 16px 50px">
        <van-button round block type="info" native-type="submit"
          >登录</van-button
        >
      </div>
    </van-form>
    <router-link class="fl-r register" to="register">
      没有账号？立即注册！
    </router-link>
  </div>
</template>
<script>
import NavTop from "@/components/nav-top/index.vue";
import storage from "@/utils/storage";
export default {
  name: "Login",
  components: { NavTop },
  data() {
    return {
      form: {
        isSevenDay: false,
      },
    };
  },
  mounted() {
    if (this.$route.query.callbackUrl) {
      storage.set("callbackUrl", this.$route.query.callbackUrl, 1000 * 10 * 60);
    }
  },
  methods: {
    toHome() {
      this.$router.push({ path: "/" });
    },
    onSubmit() {
      this.$store.dispatch("LoginByPhone", this.form).then((res) => {
        this.$toast.success("登录成功");
        if (storage.get("callbackUrl")) {
          var callbackUrl = storage.get("callbackUrl");
          storage.remove("callbackUrl");
          window.location.href =
            callbackUrl +
            "?accessToken=" +
            res +
            "&isSevenDay=" +
            this.form.isSevenDay;
        } else {
          this.$router.push({ path: "/" });
        }
      });
    },
  },
};
</script>
<style scoped>
.login .top {
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  background: #ebebeb;
  position: relative;
  text-align: center;
}
.login .top .back {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 24px;
}
.login-auto {
  margin-top: 10px;
  font-size: 14px;
  padding: 0 20px;
}
.forget-pas {
  color: #35abd8;
}
.register {
  color: #c40000;
  font-size: 14px;
  padding-right: 20px;
}
</style>